import Head from 'next/head';
import Script from 'next/script';
import { useEffect, useState } from 'react';
import { CookieSetter } from 'remote-com-shared/utils/CookieSetter';
import { createGlobalStyle } from 'styled-components';

import { cookieControlConfigFactory } from './cookieControlConfig';
import { initGTMNoScript, initGTMScript, initLayerWithConsent, initVWOScript } from './scripts';

const CookieScriptsStyleOverrides = createGlobalStyle`
  #ccc #ccc-module,
  #ccc #ccc-notify {
    .ccc-link {
      font-weight: 600;

      span {
        color: var(--colors-irisBlue) !important;
        fill: var(--colors-irisBlue) !important;
      }
    }

    #ccc-necessary-title,
    .optional-cookie-header {
      color: #000 !important;
    }

    #ccc-recommended-settings,
    #ccc-reject-settings,
    #ccc--button,
    #ccc-dismiss-button {
      font-weight: 500;
      border-radius: 20px;
    }

    #ccc-recommended-settings,
    #ccc-notify-accept,
    #ccc-dismiss-button {
      background-color: var(--colors-irisBlue) !important;
      border-color: var(--colors-irisBlue) !important;

      > span {
        color: #fff !important;
        background-color: transparent;
        font-weight: inherit;
      }
    }
    #ccc-reject-settings,
    #ccc-notify-reject {
      border-color: rgba(98, 77, 227, 0.45) !important;
    }
  }

  #ccc {
    #ccc-icon {
      margin: 0.5em;
      z-index: 9; // Must be behind notify bar

      &[aria-expanded="true"] {
        visibility: hidden;
      }
    }
  }
`;

// The expectation is these props are provided by Prismic
export function CookieScripts(cookieControlDocument) {
  const [loadVWO, setLoadVWO] = useState(false);

  function handleCookieControlLoad() {
    window.CookieControl.load(cookieControlConfigFactory(cookieControlDocument));
  }

  useEffect(() => {
    CookieSetter.whenGroupAllowed('analytics', () => {
      setLoadVWO(true);
    });
  }, []);

  return (
    <>
      <CookieScriptsStyleOverrides />
      <Script
        id="data-layer-init"
        dangerouslySetInnerHTML={{
          __html: initLayerWithConsent(),
        }}
      />
      <Script
        src="https://cc.cdn.civiccomputing.com/9/cookieControl-9.x.min.js"
        onLoad={handleCookieControlLoad}
      />
      {process.env.VWO_ENABLED && loadVWO ? (
        <>
          <Head>
            <script
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{ __html: initVWOScript() }}
            />
          </Head>
        </>
      ) : null}
      {process.env.GOOGLE_ANALYTICS_ENABLED && (
        <>
          <Script
            id="gtm-init"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: initGTMScript(),
            }}
          />
          <Head>
            <noscript
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: initGTMNoScript(),
              }}
            />
          </Head>
        </>
      )}
    </>
  );
}
